// extracted by mini-css-extract-plugin
export default {"container":"md_message_container__3M4MM","quotation_container":"md_message_quotation_container__g1fkv"};